// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2wE5y","alertIcon":"ConfirmModal_alertIcon__3j8mF"};